// Module
var code = "<template> <slot></slot> <span class=\"underline animate\" style.bind=\"underlineStyle\"> <span class=\"outline-inside\" style.bind=\"outlineStyle\"></span> </span> </template>";
// Exports
export default code;